import { computed, makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroRepresentantesPartes extends Filtro {
    tipo = 'booleano';

    get label() {
        return 'Parte sem representante (advogados ou procuradores)';
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoDadosComplementares: computed
        });
    }

    getValorOpcao(registro) {
        if (!this.carregandoDadosComplementares && this.store.mapaProcessosPartes) {
            const partesProcesso = this.store.mapaProcessosPartes[registro.processo.numeroCompleto];

            if (partesProcesso?.partes) {
                return partesProcesso.partes.findIndex((parte) => parte.quantidadeRepresentantes === 0) !== -1;
            }
        }

        return false;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoPartes;
    }

    renderCarregando() {
        return this.renderCircularProgress('partes dos processos');
    }
}
